import { useState, useEffect } from 'react'
import styles from "../../../pages/Home/ClientConfig/ClientConfig.module.css"
import * as eventManagementService from '../../../services/eventManagementService'

const EdgeRegConfig = ({
    formData,
    EdgeRegClientConfig,
    setEdgeRegClientConfig,
}) => {

    const handleChange = e => {
        setEdgeRegClientConfig({
            ...EdgeRegClientConfig,
            [e.target.name]: e.target.value,
        })
        //console.log(EdgeRegClientConfig)
    }


	const [error, setError] = useState(null)
    const errorDiv = (error)
        ?
        <ul>
            {Object.entries(error).length > 0 && Object.entries(error) &&
                Object.entries(error).map(([key, value]) => {
                    //console.log("error: " + error)
                    return <div className={value[0] === 'Test Failure' ? styles.errorMSG : styles.successMSG} key={key} >{value}</div>;
                })}
        </ul>
        : '';
    const handleTestConnection = async e => {
        e.preventDefault()
        setError(null)
        var holder = { EdgeRegClientConfig };
        try {
            await eventManagementService.testSetup(holder)
        } catch (err) {
           // console.log(err.message)
			setError(err.internalError);
        }
    }

    const isFormValid = () => {
        return formData.ClientName
            && formData.EventRegistrationSystem
            && formData.Industry
            && formData.Categories.length > 0
            && EdgeRegClientConfig.AccountToken
            && EdgeRegClientConfig.Url
            ? true
            : false
    }
    const isTestFormValid = () => {
        return EdgeRegClientConfig.AccountToken
            && EdgeRegClientConfig.Url
            ? true
            : false
    }

    return (
        <>
            <div className={styles.inputContainer}>
                <label htmlFor="AccountToken" className={styles.label}>Account Token: </label>
                <input
                    type="text"
                    autoComplete="off"
                    value={EdgeRegClientConfig.AccountToken}
                    name="AccountToken"
                    onChange={handleChange}
                />
            </div>

            <div className={styles.inputContainer}>
                <label htmlFor="Url" className={styles.label}>URL: </label>
                <input
                    type="text"
                    autoComplete="off"
                    value={EdgeRegClientConfig.Url}
                    name="Url"
                    onChange={handleChange}
                />
            </div>
			{errorDiv}
            <div className={styles.inputContainer}>
                <button disabled={!isFormValid()} className={styles.button}>
                    Submit
                </button>
                <button onClick={handleTestConnection} disabled={!isTestFormValid()} className={styles.buttonRight}>
                    Test Connection
                </button>
            </div>
        </>
    );
}

export default EdgeRegConfig;